import { money } from '../format.js';
import { Donut } from '../pictures.jsx';
import Callouts from '../Callouts.jsx';
import { StyleGrid, Companies } from '../PortfolioAnalysisView.jsx';

// What you own today, from the statements.
//
// Jake's list, and only his list (2026-09-29): the allocation pie advisors
// know from the Morningstar page, the stock-to-bond ratio, the equity style
// box, and the look-through that shows a company held directly and again
// inside three funds. No narrative about what the portfolio should be; the
// advisor says that, off the illustration. What stands out is a short list of
// facts with numbers in them.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
function fmtDate(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
  return m ? `${MONTHS[Number(m[2]) - 1]} ${Number(m[3])}, ${m[1]}` : '';
}

function scopeLine(scope) {
  if (!scope) return '';
  const dates = [...new Set(scope.accounts.map(a => a.asOf).filter(Boolean))].map(fmtDate);
  return [
    `${money(scope.analyzedValue)} across ${scope.accounts.length} supplied ${scope.accounts.length === 1 ? 'account' : 'accounts'}`,
    dates.length ? `valued ${dates.join(' and ')}` : '',
    scope.constituentsAsOf ? `fund holdings as published ${fmtDate(scope.constituentsAsOf)}` : '',
    scope.unsupportedValue > 0 ? `${money(scope.unsupportedValue)} could not be priced and is left out` : '',
  ].filter(Boolean).join('; ') + '. Only the accounts whose statements were supplied are here.';
}

export default function Investments({ analysis, allocation, callouts = [] }) {
  if (!analysis) return null;
  const { exposure, style, scope, simulated } = analysis;
  const ratio = allocation && allocation.stockPct !== null && allocation.stockPct !== undefined
    ? `${Math.round(allocation.stockPct)} / ${Math.round(allocation.bondPct)}`
    : null;
  const side = callouts.some(c => !c.hidden);

  return (
    <>
      {simulated && (
        <p className="conv-simulated">Simulated holdings for demonstration. These are fictional companies and values, not a client portfolio.</p>
      )}
      <div className="conv-module-head">
        <h2>Your investments today</h2>
        {scope ? (
          <span className="conv-quiet">{`${money(scope.analyzedValue)} across ${scope.accounts.length} ${scope.accounts.length === 1 ? 'account' : 'accounts'}`}</span>
        ) : null}
      </div>

      <div className="conv-invest-grid">
        <section className="conv-an-block">
          <h3>How it is allocated</h3>
          {allocation ? <Donut parts={allocation.parts} centre={ratio} sub={ratio ? 'stocks / bonds' : ''} /> : null}
          {allocation && (allocation.cash > 0 || allocation.other > 0) && ratio ? (
            <p className="conv-caption">
              {`The ratio compares stocks with bonds only; ${[
                allocation.cash > 0 ? `cash (${Math.round(allocation.cashPct)}%)` : '',
                allocation.other > 0 ? `unclassified holdings (${money(allocation.other)})` : '',
              ].filter(Boolean).join(' and ')} ${allocation.cash > 0 && allocation.other > 0 ? 'are' : 'is'} shown separately.`}
            </p>
          ) : null}
        </section>
        <StyleGrid style={style} brief />
      </div>

      <div className={`conv-invest-row${side ? ' has-side' : ''}`}>
        <Companies exposure={exposure} limit={5} title="What you own" brief />
        <Callouts items={callouts} />
      </div>

      <p className="conv-caption">{scopeLine(scope)}</p>
    </>
  );
}
